var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeAbsenceCold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F1_Mode_absence_cold_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.56 21.74l16.5 13.43v21.75h-33V50c.167.01.334.01.5 0 2.31 0 4.5-1.77 4.5-4V34a5.55 5.55 0 00-1.43-3.2l12.93-9.06zm27.63-7.5l-4.68-2.76 4.75-2.81a1.5 1.5 0 00-1.53-2.58l-4.67 2.76V3.48a1.5 1.5 0 10-3 0v5.37l-4.67-2.76a1.51 1.51 0 00-2.24 1 1.54 1.54 0 00.77 1.62l4.69 2.78-4.68 2.76a1.55 1.55 0 00-.76 1.69 1.5 1.5 0 002.22.94l4.67-2.76v5.37a1.5 1.5 0 103 0v-5.38l4.67 2.76a1.5 1.5 0 002.27-.94 1.55 1.55 0 00-.81-1.69zM22 28a3 3 0 004.2.34c.122-.1.233-.215.33-.34a3 3 0 10-4.55 0H22zm11.1 17.5V35a4 4 0 00-.8-2.39A3.999 3.999 0 0029 31h-9.91a4 4 0 00-4 4v10.5a1.5 1.5 0 103 0V35a1 1 0 011-1h1v27.5a1.5 1.5 0 103 0V49h2v12.5a1.5 1.5 0 103 0V34h1a1.08 1.08 0 011 1v10.5a1.5 1.5 0 103 0h.01z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "F1_Mode_absence_cold_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/F1_Mode_absence_cold.03c43a4f.svg";
export { SvgF1ModeAbsenceCold as ReactComponent };